import React, { Component, Fragment } from 'react';
import {Helmet} from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import {clear_auth, set_auth} from "../../../reducers/Auth";
import {connect} from "react-redux";
import {Empty, Spin, Tooltip} from "antd";
import {pageNumber} from "../../../functions/functionGeneral";
import Paging from "../../paging";
import PlusIcon from "../../../assets/icons/plus-white.svg";
import Add from "./add";
import Edit from "./edit";
import Swal from "sweetalert2";
import refreshIcon from "../../../assets/icons/refresh.svg";

class Ip_Whitelist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data : [],
            currentPage : 0,
        }
        this.handlePageClick = this.handlePageClick.bind(this)
    }

    loadData() {
        this.setState({loading: true})
        let form = {
            filter_ip   : this.state.filter_ip,
            paginate    : 10,
            page        : this.state.currentPage + 1,
        }
        this.props.request("whitelist/list", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        data: response.data.data,
                        loading: false,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                    })
                }
            });
    }

    handleDelete() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        whitelist_id    : this.state.whitelist_id
                    }
                    this.props.request("whitelist/delete", form, 'POST')
                        .then(response => {
                            if (response && response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.loadData()
                            }
                        });
                }
            })
    }

    handlePageClick(data) {
        let selected = data.selected
        this.setState({ currentPage: selected }, () => {
            this.loadData()
        });
    }

    handleInputIP = (e) => {
        let name = e.target.name;
        let value = e.target.value.replace(/[^0-9.x]/g, "")
        let parts = value.split(".")

        parts = parts.map((part) => part.slice(0, 3)).slice(0, 4)
        value = parts.join(".")

        this.setState({[name] : value})
    }

    componentDidMount() {
        this.loadData()
    }

    render() {
        let no = 0;
        return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Daftar IP Whitelist - Presensi</title>
                        <meta name="description" content="Daftar IP Whitelist" />
                    </Helmet>
                    <Breadcrumb parent="Settings" title="Daftar IP Whitelist"/>
                    <Add
                        handleInputIP={this.handleInputIP}
                        modal_add={this.state.modal_add}
                        ip_start={this.state.ip_start}
                        ip_end={this.state.ip_end}
                        request={(action, data, method = 'GET') => this.props.request(action, data, method)}
                        changeState={(state, callback) => {
                            this.setState(state, () => {
                                if (typeof callback != 'undefined')
                                    callback()
                            })
                        }}
                        loadData={() => this.loadData()}
                    />
                    <Edit
                        handleInputIP={this.handleInputIP}
                        modal_edit={this.state.modal_edit}
                        isRange={this.state.isRange}
                        data={this.state}
                        request={(action, data, method = 'GET') => this.props.request(action, data, method)}
                        changeState={(state, callback) => {
                            this.setState(state, () => {
                                if (typeof callback != 'undefined')
                                    callback()
                            })
                        }}
                        loadData={() => this.loadData()}
                    />
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-5 d-flex">
                                        <input type='text' onChange={this.handleInputIP}
                                               name='filter_ip' value={this.state.filter_ip}
                                               className="form-control fltr-nama mr-2 mb-2"
                                               placeholder="&#xF002;  Cari IP +  (ex : 192.168.1.x)"
                                               onKeyDown={(e) => {
                                                   if (e.key === "Enter") {
                                                       this.loadData()
                                                   }
                                               }}
                                        />
                                        <div>
                                            <button className="input-select-style button-reset mt-0"
                                                    style={{width: "44px"}} onClick={() => {
                                                this.setState({
                                                    filter_ip: ""
                                                }, () => this.loadData())
                                            }}>
                                                <img src={refreshIcon} alt=""/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-7 justify-content-end">
                                        <button
                                            className="btn btn-primary text-capitalize width-filter pull-right"
                                            onClick={() => {
                                                this.setState({modal_add: true});
                                            }}
                                        >
                                            <img src={PlusIcon} alt=""/> Tambah IP Whitelist
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            {!this.state.loading && this.state.data.length === 0 ?
                                                <Empty description="Data Kosong"
                                                       image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"/>
                                                :
                                                <div>
                                                    <table className="table mb-5 table-striped table-borderless">
                                                        <thead>
                                                        <tr>
                                                            <th className='lembur-th-style text-center' width="50">#</th>
                                                            <th className='lembur-th-style'>IP Whitelist</th>
                                                            <th className='lembur-th-style'>Tanggal dibuat</th>
                                                            <th className='lembur-th-style'>Tanggal diubah</th>
                                                            <th className='lembur-th-style text-center'>Aksi</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.loading ?
                                                            <tr>
                                                                <td colSpan="9" style={{
                                                                    textAlign: "center",
                                                                    backgroundColor: "#FFFFFF"
                                                                }}>
                                                                    <Spin size="large"
                                                                          tip="Sedang Memuat Data"
                                                                          style={{
                                                                              width: '100%',
                                                                              margin: 'auto',
                                                                              marginBottom: '10px',
                                                                              marginTop: '10px'
                                                                          }}/>
                                                                </td>
                                                            </tr>
                                                            :
                                                            this.state.data.map((item, index) => {
                                                                no += 1
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="lembur-td-style text-center">{pageNumber(no, this.state.perPage, this.state.currentPage)}</td>
                                                                        <td className="lembur-td-style">{item.whitelist_allowed_ip}</td>
                                                                        <td className="lembur-td-style">{item.created_at}</td>
                                                                        <td className="lembur-td-style">{item.updated_at}</td>
                                                                        <td className="lembur-td-style text-center">
                                                                            <Tooltip trigger={'click'} zIndex={1} placement="bottom" color={'#fff'} title={
                                                                                <div className={'text-dark'}>
                                                                                    <a onClick={() => {
                                                                                        const {whitelist_allowed_ip, whitelist_id} = item;
                                                                                        let ip_start = whitelist_allowed_ip;
                                                                                        let ip_end = null;
                                                                                        let isRange = false;
                                                                                        if (whitelist_allowed_ip.includes(" - ")) {
                                                                                            [ip_start, ip_end] = whitelist_allowed_ip.split(" - ").map(ip => ip.trim());
                                                                                            isRange = true;
                                                                                        }
                                                                                        this.setState({ip_start, ip_end, isRange, whitelist_id, modal_edit: true});
                                                                                    }}>Edit</a><br/>
                                                                                    <a onClick={() => {
                                                                                        this.setState({
                                                                                            whitelist_id: item.whitelist_id
                                                                                        })
                                                                                        this.handleDelete()
                                                                                    }} className={'text-danger'}>Hapus</a>
                                                                                </div>
                                                                            }>
                                                                                <a><i
                                                                                    className="fa fa-ellipsis-v"
                                                                                    style={{
                                                                                        width: 35,
                                                                                        fontSize: 18,
                                                                                        padding: 11,
                                                                                        color: 'rgb(51 51 51)'
                                                                                    }}
                                                                                ></i></a>
                                                                            </Tooltip>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                        <div className="row">
                                            <div className='col font-14 fw-500 m-auto'>
                                                Menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} Data.
                                            </div>
                                            <div className="col">
                                                <Paging
                                                    className="float-right"
                                                    handlePageClick={this.handlePageClick}
                                                    pageCount={this.state.pageCount}
                                                    currentPage={this.state.currentPage}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Ip_Whitelist);